import Immutable from 'seamless-immutable';
import commonApi from '@/api/common';
import raysserveapi from '@/api/raysserveapi';
import ai from '@/constants/ai';

const INIT_BREAD = {
  name: '',
  path: [],
  action: ''
};

export default {
  namespace: 'common',
  state: Immutable({
    dynamicList: [],
    breadCrumbs: { ...INIT_BREAD },
    context: {},
    aiCostRule: [],
    uploadConfig: {},
    /** 后台任务 */
    newDownloadTask: null
  }),
  reducers: {
    update: (state, { data, field }) => state.merge({ [field]: data }),
    addRoute: (state, { data }) => {
      let dynamicArr = [];
      if(Array.isArray(data)) {
        dynamicArr = data;
      }
      if(data.constructor === Object && 'path' in data) {
        if(!state.dynamicList.some(v => v.path === data.path)) {
          dynamicArr = [...state.dynamicList, data];
        }
      }
      return state.merge({
        dynamicList: dynamicArr
      });
    },
    removeRoute: (state, { data }) => {
      let dynamicArr = [];
      if(data.constructor === Object && 'path' in data) {
        dynamicArr = state.dynamicList.filter(v => v.path !== data.path);
      }
      return state.merge({
        dynamicList: dynamicArr
      });
    },
    addBreadCrumb: (state, { data }) => {
      let breadcrumbValues = { ...INIT_BREAD };
      if(typeof data === 'string') {
        breadcrumbValues.path = [data];
      }
      if(data.path) {
        if(!Array.isArray(data.path)) {
          return console.error(`path must be Array`);
        }
        breadcrumbValues = data;
      }
      return state.merge({
        breadCrumbs: breadcrumbValues
      });
    },
    removeBreadCrumb: (state) => {
      return state.merge({
        breadCrumbs: { ...INIT_BREAD }
      });
    },
    removeDownloadTask: state => {
      return state.merge({
        newDownloadTask: null
      });
    }
  },
  actions: {
    addRoute: function(router) {
      return {
        type: 'common/addRoute',
        data: router
      };
    },
    removeRoute: function(router) {
      return {
        type: 'common/removeRoute',
        data: router
      };
    },
    addBreadCrumb: function(breadcrumb) {
      return {
        type: 'common/addBreadCrumb',
        data: breadcrumb
      };
    },
    removeBreadCrumb: function(breadcrumb) {
      return {
        type: 'common/removeBreadCrumb',
        data: breadcrumb
      };
    },
    setSearchOperation(key, searchOptions) {
      return {
        type: `common/update/${key}`,
        field: key,
        data: searchOptions
      };
    },
    resetSearchOperations(key) {
      return {
        type: `common/update/${key}`,
        field: key,
        data: {}
      };
    },
    setContext: function(key, context) {
      return {
        type: `common/update/${key}`,
        field: key,
        data: context
      };
    },
    setUploadConfig(data) {
      return {
        type: 'common/update/updateUploadConfig',
        field: 'uploadConfig',
        promise: commonApi.getUploadParam({
          bizCode: 'industry'
        })
          .then(res => {
            return res;
          })
      };
    },
    addDownloadTask(data) {
      const field = 'newDownloadTask';
      return {
        type: `common/update/${field}`,
        field,
        data
      };
    },
    removeDownloadTask() {
      return {
        type: 'common/removeDownloadTask'
      };
    },
    getAiCostRule() {
      return {
        type: 'common/update/updateaAiCostRule',
        field: 'aiCostRule',
        promise: raysserveapi.listAiCostRule().then(res => {
          return res.map((item, index) => {
            const info = ai.AI_TOOLS.find(item2 => item.writeType === item2.writeType);
            return {
              ...item,
              title: (info && info.costRule) ?
                (index + 1) + '、' + info.name + '：' + info.costRule.replace('{letters}', item.letters).replace('{unitCost}', item.unitCost)
                : ''
            };
          });
        })
      };
    }
  }
};
